import { RANGE_PRESETS } from '@/lib/channel';

export function RangeSwitcher({ preset, start, end, onChange }) {
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {RANGE_PRESETS.map((item) => {
        const active = preset === item.id;
        return (
          <button
            key={item.id}
            type="button"
            onClick={() => onChange({ preset: item.id, start, end })}
            className={`px-3 py-1.5 rounded-full text-xs font-semibold transition-colors ${
              active
                ? 'bg-[#13322d] text-[#34d399] border border-[#214f48]'
                : 'text-[#7d8799] bg-[#0c1018] border border-[#1f2635] hover:text-white'
            }`}
          >
            {item.label}
          </button>
        );
      })}
      {preset === 'custom' && (
        <div className="flex items-center gap-1.5">
          <input
            type="date"
            value={start || ''}
            onChange={(event) => onChange({ preset: 'custom', start: event.target.value, end })}
            className="h-8 rounded-full bg-[#0c1018] border border-[#1f2635] text-white text-xs px-2"
          />
          <input
            type="date"
            value={end || ''}
            onChange={(event) => onChange({ preset: 'custom', start, end: event.target.value })}
            className="h-8 rounded-full bg-[#0c1018] border border-[#1f2635] text-white text-xs px-2"
          />
        </div>
      )}
    </div>
  );
}
